import React from 'react';
import styled from '@emotion/styled';

const ErrorBox = styled.div({
  display: `flex`,
  flexDirection: `column`,
  justifyContent: `center`,
  alignItems: `center`
});

const StyledError = styled.div`
  color: ${props => props.color};
  margin-bottom: 5px;
  margin: 2px 4px;
`;

const severityColors = ['red', 'orange', 'white'];

const ErrorText = ({ errors }) => {
  return (
    <ErrorBox>
      {errors.map(error => {
        return (
          <StyledError color={severityColors[error.severity] || 'white'} key={error.message}>
            {error.show ? error.message : ``}
          </StyledError>
        );
      })}
    </ErrorBox>
  );
};

export default ErrorText;
